export default __webpack_public_path__ + "static/logo-full-dark-6e611544c107cddb5ca19a562b8ec399.svg";